var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',{staticClass:"text-center mb-4 mt-4"},[_vm._v("下载历史")]),_c('div',{staticClass:"page-title-desc text-center mb-4 mt-4"},[_vm._v("您在云联万维官网网站，下载镜像的历史信息")]),_c('page-body',[_c('history-list',{attrs:{"id":_vm.listId}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }